export function getBlockComponentOptions(block) {
    return {
        ...block.component?.options,
        ...block.options
    };
}
